import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SnookerScoreboardStats } from '../../../../../scoreboards/models/scoreboard-stats';

@Component({
    selector: 'ms-my-bets-snooker-scoreboard-stats',
    templateUrl: './my-bets-snooker-scoreboard-stats.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
})
export class MyBetsSnookerScoreboardStatsComponent {
    vm = input.required<SnookerScoreboardStats>();
}
